import React, { useState } from "react";
import { Grid } from "@mui/material";
import styled from "styled-components";
import { ReactSVG } from "react-svg";
import { formatCPF } from "../../../utils/formats";
import { toast } from "react-toastify";

import Modal from "../../../components/Modal";
import api from "../../../services/api";
import FrontCredito from "../../../assets/navbar/Front_Credito_on_light_blue.svg";
import SearchableSelect from "../../../components/SearchableSelect";
import Input from "../../../pages/ViewCreditProposal/detail/Input";
import Button from "../../../components/Button-v2";

const selectLabelStyles = {
  paddingBottom: "3.3px",
  lineHeight: 1.17,
  fontWeight: "normal",
  fontSize: "12px",
  opacity: 0.9,
};

const StatusModal = (props) => {
  const {
    open,
    onClose,
    status,
    statusLoading,
    numeroCpfCnpj,
    nomeDoCliente,
    numeroProposta,
    updateTable,
  } = props;

  const [selectedStatus, setSelectedStatus] = useState(undefined);
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setSelectedStatus(undefined);
    setReason("");
    onClose();
  };

  const saveStatus = () => {
    setLoading(true);
    const data = {
      numeroProposta,
      proximoStatus: selectedStatus.numeroProximoStatus,
      cpfUsuario: numeroCpfCnpj,
      motivos: reason,
    };
    api
      .post("/api/front-credito/altera-status-proposta", data)
      .then(() => {
        toast.success("Alterado o status da proposta com sucesso.");
        handleClose();
        updateTable();
      })
      .catch(() => {
        toast.error("Erro ao salvar o status.");
      })
      .finally(() => setLoading(false));
  };

  const disableButton =
    !selectedStatus ||
    (selectedStatus && selectedStatus.exigirObservacao && !reason);

  return (
    <Modal open={open} onClose={handleClose}>
      <Header>
        <IconWrapper>
          <ReactSVG src={FrontCredito} />
        </IconWrapper>
        <TitleWrapper>
          <Title>Front de crédito</Title>
          <Subtitle>Análise de Crédito</Subtitle>
        </TitleWrapper>
      </Header>
      <Body>
        <Label>Troca de status</Label>
        <Card>
          <Grid container spacing={3}>
            <Grid item xs={12} md={3}>
              <Input
                disabled
                color="#f6f6f6"
                label="Proposta"
                loading={loading}
                value={numeroProposta}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Input
                disabled
                color="#f6f6f6"
                label="CPF/CNPJ"
                loading={loading}
                value={formatCPF(numeroCpfCnpj)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                disabled
                label="Nome do cliente"
                align="flex-start"
                type="textarea"
                loading={loading}
                value={nomeDoCliente}
              />
            </Grid>
            <Grid item md={12}>
              <SearchableSelect
                entries={status}
                label="Alterar para"
                labelStyles={selectLabelStyles}
                isLoading={statusLoading}
                parser={(it) => ({
                  value: it.numeroProximoStatus,
                  label: it.descricao,
                })}
                placeholder="Selecione a opção desejada"
                selected={selectedStatus}
                setSelected={setSelectedStatus}
              />
            </Grid>
            <Grid item md={12}>
              <Input
                label="Motivos"
                value={reason}
                disabled={loading}
                onChange={setReason}
                defaultValue=""
                height={200}
                type="textarea"
                align="flex-start"
              />
            </Grid>
            <ButtonWrapper>
              <Button
                height="34px"
                width="150px"
                loading={loading}
                disabled={disableButton}
                onClick={saveStatus}
              >
                Alterar status
              </Button>
            </ButtonWrapper>
          </Grid>
        </Card>
      </Body>
    </Modal>
  );
};

const Header = styled.div`
  display: flex;
  flex-direction: row;

  border-bottom: 3px solid #00a2e0;
`;

const IconWrapper = styled.div`
  width: 50px;
  height: 50px;

  svg {
    width: 50px;
    height: 50px;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: space-between;

  margin: 0px 5px;
`;

const Title = styled.div`
  font-size: 18px;
  font-family: Roboto;
  font-weight: bold;
  line-height: 1.22;
  color: #383838;
`;

const Subtitle = styled.div`
  font-size: 15px;
  font-family: Roboto;
  font-weight: 500;
  line-height: 1.2;
  color: #747576;
`;

const Body = styled.div`
  margin-top: 32px;
  width: 700px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;

  margin-top: 32px;
`;

export const Label = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${({ justify }) => justify || "flex-start"};
  align-items: ${({ align }) => align || "center"};
  font-size: ${({ fontSize }) => (fontSize != undefined ? fontSize : "12px")};
  font-family: Roboto;
  width: ${({ width }) => (width != undefined ? width : "100%")};
  line-height: 14px;
  opacity: 0.9;
  color: #747576;
  margin-top: ${({ marginTop }) => (marginTop != undefined ? marginTop : 0)}px;
  margin-bottom: ${({ marginBottom }) =>
    marginBottom != undefined ? marginBottom : 10}px;
  height: ${({ height }) => (height != undefined ? height : "auto")};
`;

export const Card = styled.div`
  padding: 21px 19px 26.4px 20px;
  border-radius: 6px;
  border: solid 1px #b9b9ba;
`;

export default StatusModal;
